import cx from 'classnames';
import SVG from 'react-inlinesvg';

import closeSvg from 'assets/icons/close.svg';

type PanelProps = {
  isOpen: boolean;
  toggle: () => void;
  title?: string;
  children?: React.ReactNode;
};

const Panel = ({ isOpen, toggle, title = '', children = null }: PanelProps): React.ReactElement => {
  return (
    <div
      data-test-id="read-more-panel"
      className={cx(
        'motion-safe:transition-all motion-safe:ease-out motion-safe:duration-1000 absolute overflow-y-scroll h-full w-full rounded-t-3xl bg-neutral-100 z-10',
        {
          'top-0': isOpen,
          'top-full': !isOpen,
        },
      )}
    >
      <div className="mb-6 px-8 py-4 sticky top-0 bg-neutral-100 z-10 shadow">
        <div className="flex flex-row items-start justify-between">
          <h4 className="sub-header-lg text-neutral-950-opacity-80">{title}</h4>
          <button type="button" onClick={toggle}>
            <SVG src={closeSvg} className="text-neutral-950-opacity-60 hover:text-neutral-950-opacity-80" />
          </button>
        </div>
      </div>
      <div className="px-8 pb-4">{children}</div>
    </div>
  );
};

export default Panel;
